var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.075C3 10.8038 3 8.66823 3.8444 7.04269C4.55597 5.67287 5.67287 4.55597 7.04269 3.8444C8.66823 3 10.8038 3 15.075 3H32.925C37.1962 3 39.3318 3 40.9573 3.8444C42.3271 4.55597 43.444 5.67287 44.1556 7.04269C45 8.66823 45 10.8038 45 15.075V32.925C45 37.1962 45 39.3318 44.1556 40.9573C43.444 42.3271 42.3271 43.444 40.9573 44.1556C39.3318 45 37.1962 45 32.925 45H15.075C10.8038 45 8.66823 45 7.04269 44.1556C5.67287 43.444 4.55597 42.3271 3.8444 40.9573C3 39.3318 3 37.1962 3 32.925V15.075Z",
    fill: "url(#paint0_linear_7647_226931)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9313 36.2905L11.71 26.0691C12.5831 31.2937 16.7067 35.4174 21.9313 36.2905Z",
    fill: "#F2F3F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5576 23.3062L24.694 36.4425C25.4732 36.3996 26.2334 36.2854 26.9681 36.1058L11.8943 21.032C11.7147 21.7667 11.6005 22.5269 11.5576 23.3062Z",
    fill: "#F2F3F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 19.0762L28.9256 35.451C29.5212 35.1945 30.0928 34.893 30.6361 34.5506L13.4512 17.3657C13.1088 17.909 12.8073 18.4806 12.5508 19.0762Z",
    fill: "#F2F3F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5576 15.865C16.8428 13.2154 20.2244 11.5383 23.9979 11.5383C30.8801 11.5383 36.4594 17.1176 36.4594 23.9999C36.4594 27.7733 34.7823 31.155 32.1327 33.4401L14.5576 15.865Z",
    fill: "#F2F3F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7647_226931",
    x1: 3,
    y1: 45,
    x2: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29359B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6068CA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinear);
export default __webpack_public_path__ + "static/media/logo-linear.dba98a2f.svg";
export { ForwardRef as ReactComponent };